import React from 'react';
import { Container } from 'react-bootstrap';
import './GlobalPresence.css';

const GlobalPresence: React.FC = () => {
  return (
    <section className="global-presence-banner">
      <Container>
        <div className="global-presence-content">
          <h2 className="global-presence-title">
            OUR GLOBAL PRESENCE: <span className="countries-list">UK, USA, UAE, FRANCE, INDIA</span>
          </h2>
        </div>
      </Container>
    </section>
  );
};

export default GlobalPresence;
